import React from 'react';

const Legence = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['business_center', 'apartment', 'corporate_fare', 'domain', 'energy_savings_leaf', 'insights', 'public', 'verified'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Our Parent Company
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              We Are Legence
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Making Buildings Better Since 1914
            </p>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Bel-Aire Mechanical & Legence</h2>
            <p>Part of a leading Energy Transition Accelerator™</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Bel-Aire Mechanical is a member of the <strong style={{color: 'var(--accent-blue)'}}>Legence family of companies</strong>. 
                Legence, a <strong style={{color: 'var(--accent2-red)'}}>Blackstone portfolio company</strong>, is an 
                <strong style={{color: 'var(--accent-blue)'}}> Energy Transition Accelerator™</strong> that provides advisory services 
                and implementation focused on financing, designing, building, and servicing complex systems in mission-critical 
                and high performance facilities.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                With <strong style={{color: 'var(--accent-blue)'}}>five decades of expertise</strong> in the built environment, 
                Legence has a proven track record of reducing carbon emissions, implementing renewables, lowering utility costs 
                through efficiency consumption, and making systems run better at unmatched speed and scale.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Legence Energy Transition Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto', marginBottom: '3rem'}}>
            <div style={{background: 'var(--secondary-light)', padding: '2.5rem', borderRadius: '10px', marginBottom: '2rem', textAlign: 'center'}}>
              <h3 style={{fontSize: '1.5rem', color: 'var(--accent-blue)', marginBottom: '1.5rem'}}>Learn More About Legence</h3>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Discover how Legence is transforming the built environment through innovative energy solutions
              </p>
              <a 
                href="https://www.wearelegence.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)',
                  color: 'var(--white)',
                  padding: '1rem 2.5rem',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  boxShadow: '0 4px 15px rgba(0, 104, 166, 0.3)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 20px rgba(0, 104, 166, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(0, 104, 166, 0.3)';
                }}
              >
                Visit Legence Website →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Legence Impact Section */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 50%, rgba(0, 104, 166, 0.1) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Legence Impact</h2>
            <p>Combining cutting edge engineering solutions with expert craftsmanship to deliver exceptional results</p>
          </div>
          
          <div style={{maxWidth: '1200px', margin: '0 auto'}}>
            <div className="legence-impact-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(4, 1fr)', 
              gap: '2rem'
            }}>
              <div className="legence-impact-card legence-card-blue" style={{
                background: 'var(--white)', 
                padding: '2rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                border: '3px solid var(--accent-blue)'
              }}>
                <div style={{fontSize: '3rem', marginBottom: '1rem', color: 'var(--accent-blue)'}}>1,200+</div>
                <div style={{fontSize: '1.1rem', fontWeight: 'bold', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Engineers & Consultants</div>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>MEP engineers and consultants delivering unparalleled expertise</p>
              </div>
              
              <div className="legence-impact-card legence-card-red" style={{
                background: 'var(--white)', 
                padding: '2rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                border: '3px solid var(--accent2-red)'
              }}>
                <div style={{fontSize: '3rem', marginBottom: '1rem', color: 'var(--accent2-red)'}}>10M+</div>
                <div style={{fontSize: '1.1rem', fontWeight: 'bold', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Net Zero SQ FT</div>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Designed net zero buildings and distributed generation</p>
              </div>
              
              <div className="legence-impact-card legence-card-blue" style={{
                background: 'var(--white)', 
                padding: '2rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                border: '3px solid var(--accent-blue)'
              }}>
                <div style={{fontSize: '3rem', marginBottom: '1rem', color: 'var(--accent-blue)'}}>3,400+</div>
                <div style={{fontSize: '1.1rem', fontWeight: 'bold', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Technicians & Craftspeople</div>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>HVAC, plumbing, electrical and sheet metal professionals</p>
              </div>
              
              <div className="legence-impact-card legence-card-red" style={{
                background: 'var(--white)', 
                padding: '2rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                border: '3px solid var(--accent2-red)'
              }}>
                <div style={{fontSize: '3rem', marginBottom: '1rem', color: 'var(--accent2-red)'}}>5.5B+</div>
                <div style={{fontSize: '1.1rem', fontWeight: 'bold', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Advisory SQ FT</div>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Maximizing efficiency across 25,000+ buildings</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Markets & Solutions Section */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Markets We Serve</h2>
            <p>With in-house engineering, consulting, installation, and maintenance expertise and decades of experience</p>
          </div>
          
          <div style={{maxWidth: '1200px', margin: '0 auto'}}>
            <div className="legence-markets-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(2, 1fr)', 
              gap: '2rem'
            }}>
              <div className="legence-market-card legence-market-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2.5rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 6px 20px rgba(0, 104, 166, 0.2)'
              }}>
                <div style={{fontSize: '4rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>engineering</span></div>
                <h3 style={{fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--white)'}}>Engineering & Consulting</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>Design HVAC and MEP systems, develop energy-saving strategies, and provide program/project management services.</p>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Engineering & Design</li>
                  <li>Program & Project Management</li>
                  <li>Energy Efficiency Consulting</li>
                  <li>Sustainability Advisory</li>
                </ul>
              </div>
              
              <div className="legence-market-card legence-market-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2.5rem', 
                borderRadius: '12px', 
                textAlign: 'center',
                boxShadow: '0 6px 20px rgba(171, 22, 54, 0.2)'
              }}>
                <div style={{fontSize: '4rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>build</span></div>
                <h3 style={{fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--white)'}}>Installation & Maintenance</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>Fabricate, install, and maintain HVAC systems, process piping and other MEP systems in mission-critical facilities.</p>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Installation & Fabrication</li>
                  <li>Maintenance & Service</li>
                  <li>Mission-Critical Systems</li>
                  <li>Preventive & Corrective Maintenance</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Legence;
